import { render, staticRenderFns } from "./SubHeaderEdit.vue?vue&type=template&id=4b77d0f8&"
import script from "./SubHeaderEdit.vue?vue&type=script&lang=js&"
export * from "./SubHeaderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports